import React, {useContext, useState} from 'react';
import {useHttp} from "../../../hooks/http.hook";
import FormInput from "../../../components/Inputs/FormInput/FormInput";
import {useFormik} from "formik";
import {AuthContext} from "../../../context/AuthContext";
import {Link} from "react-router-dom";
import styled from "styled-components";

function OrganizationAuthForm() {
    const {request} = useHttp()
    const {login} = useContext(AuthContext)
    const [status, setStatus] = useState()
    const formik = useFormik({
        initialValues: {
            login: '',
            password: ''
        }, onSubmit: (values) => {
            req(values)

        }
    })
    const baseURL = process.env.REACT_APP_BASE_URL

    const req = async (formData) => {
        const {
            data,
            status
        } = await request(`${baseURL}/api/v2/organizations/login`, 'POST', formData, {})
        setStatus(status)
        if (status === 200) {
            await login(data.data[0], data.data[1])
        }
        return data
    }


    return (<>
            <form key={'orXLgLogin'} onSubmit={formik.handleSubmit}
                  className="auth__login-form auth__organization__login-form">

                <AttentionWrapper>
                    {
                        status === 400 ||
                        status === 401 ?
                            <div className='qrAttention'> Введен неверный логин или пароль </div> :
                            ''
                    }
                </AttentionWrapper>


                <FormInput
                    keyss={'login'}
                    name={'login'}
                    onChange={formik.handleChange}
                    hideIcon>
                    Логин
                </FormInput>
                <FormInput
                    name={'password'}
                    type={'password'}
                    minLength={6}
                    maxLength={15}
                    onChange={formik.handleChange}
                    hideIcon>
                    Пароль
                </FormInput>

                <div style={{marginTop: '0', marginBottom: '20px'}} className="form__options">
                    <div>
                        <Link to={process.env.REACT_APP_URL_PREFIX + "/restore/organization"}>
                            <div className="restore-password">Забыли пароль?</div>
                        </Link>
                    </div>
                </div>


                <div className="form-buttons">
                    <button className="sign-in__button" type="submit">Войти</button>
                    <Space className="space"/>
                </div>
            </form>
        </>

    );
}

const AttentionWrapper = styled.div`
  min-height: 55px;
  width: 100%;
  margin-bottom: 10px;
`
const Space = styled.div`
  height: 50px;
  width: 100px;
  display: none;
  @media (max-width: 1100px) {
    display: block;
  }
`
export default OrganizationAuthForm;
